const e = {
  name: "Message",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02946 3 3.00002 7.02944 3.00002 12C3.00002 13.6677 3.4527 15.2267 4.24127 16.564C4.37958 16.7986 4.41626 17.0794 4.34284 17.3416L3.44233 20.5577L6.65843 19.6572C6.92064 19.5838 7.20144 19.6204 7.43599 19.7588C8.77333 20.5473 10.3323 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1.00002 12C1.00002 5.92487 5.92489 1 12 1C18.0752 1 23 5.92487 23 12C23 18.0751 18.0752 23 12 23C10.1203 23 8.34825 22.5277 6.79874 21.6948L2.26965 22.963C1.92176 23.0604 1.54838 22.9626 1.29292 22.7071C1.03746 22.4516 0.93965 22.0783 1.03706 21.7304L2.3052 17.2013C1.47232 15.6518 1.00002 13.8797 1.00002 12Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Message
};
